export default defineNuxtRouteMiddleware((to) => {
  const formType = to.query['formType'] || '';
  const brand = sessionStorage.getItem('sbform-brand') || '';
  if (brand === 'YM' || formType === '2') {
    setPageLayout('default-ym');
  } else if (brand === 'YahooSmartphonePurchase' || formType === '3') {
    setPageLayout('default-yahoo-smartphone-purchase');
  }
});
